/* eslint-disable sonarjs/no-duplicate-string */
import {
    animate,
    AnimationTriggerMetadata,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";

/**
 * Expand and collapse animation
 */
export const getExpandCollapseAnimation: AnimationTriggerMetadata = trigger(
    "expandCollapseAnimation",
    [
        state(
            "open",
            style({
                height: "*",
                display: "block",
                opacity: 1,
                transition:
                    "opacity 0.75s, display 0.25s allow-discrete, height 0,5s ease-in-out",
            }),
        ),
        state(
            "closed",
            style({
                height: 0,
                display: "none",
                opacity: 0,
                transition:
                    "opacity 0.75s, display 0.75s allow-discrete, height 0,5s ease-in-out",
            }),
        ),
        transition("open <=> closed", [animate("{{duration}}ms ease-in-out")]),
    ],
);
